const SetPage = (page)=>{

     sessionStorage.setItem("page",JSON.stringify(page))
}
export default SetPage